function Status({ correct }) {
  return (
    <div className={`quiz-status quiz-status--${correct ? 'correct' : 'wrong'}`} role="status">
      {correct ? 'Correct!' : 'Wrong!'}
    </div>
  );
}

export default Status;
